<template>
	<main class="u-flex">
		<posts type="list"></posts>
	</main>
</template>

<script>
// Import components
import posts from '@/components/posts/posts'

export default {
	name: 'posts-listing',
	components: {
		posts
	}
}
</script>



// WEBPACK FOOTER //
// postsListing.vue?8dd6fe5c